import { SetStateAction } from "react";
import { MenuIcon, CloseIcon } from "@talladega/icons";
import { Button } from "../Button";

type Props = {
  onMenuIconClick: (value: SetStateAction<boolean>) => void;
  isMenuOpen: boolean;
  menuColor: string;
  className?: string;
};

export const HamburgerMenu = ({
  onMenuIconClick,
  isMenuOpen,
  menuColor,
  className = "",
}: Props) => {
  return (
    <Button
      fill="link"
      spacing="tight-hug"
      size="small"
      className={`px-[.1rem] block lg:hidden order-2 lg:order-3 ${className}`}
      buttonStyle="transparent"
      onClick={() => onMenuIconClick((prevState) => !prevState)}
    >
      {!isMenuOpen ? (
        <MenuIcon fontSize="2em" className={`${menuColor}`} />
      ) : (
        <CloseIcon fontSize="2em" className={`${menuColor}`} />
      )}
    </Button>
  );
};

export default {};
